export default "__VITE_ASSET__D1ZUPa4M__"